// React Creator:
import React from "react";
import { createRoot } from "react-dom/client";
// Redux Creator:
import { Provider } from "react-redux";
import { store } from "./app/store";
// MUI Components:
import { IconButton, SvgIcon } from "@mui/material";
import { SnackbarProvider, useSnackbar } from "notistack";
// Components:
import App from "./App";
// MUI Styles:
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { theme } from "./configs/MUI/theme";
// Styles:
import "./index.css";
// Icones:
import { ReactComponent as CloseIcon } from "./assets/icons/close-icon.svg";
// Service worker
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import NetworkStatusIndicator from "./components/global/network-status-indicator/NetworkStatusIndicator";


const container = document.getElementById("root")!;
const root = createRoot(container);

const SnackbarCloseButton = ({ snackbarKey }: any) => {
  const { closeSnackbar } = useSnackbar();

  return (
    <IconButton onClick={() => closeSnackbar(snackbarKey)}>
      <SvgIcon
        component={CloseIcon}
        inheritViewBox
        sx={{
          width: "12px",
          height: "12px",
          color: "#FFFFFF",
        }}
      />
    </IconButton>
  );
};

root.render(
  <React.Fragment>
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <CssBaseline />
        <SnackbarProvider
          maxSnack={3}
          autoHideDuration={6000}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          action={(snackbarKey) => (
            <SnackbarCloseButton snackbarKey={snackbarKey} />
          )}
          className="my-snackbar"
        >
          <App />
          <NetworkStatusIndicator />
        </SnackbarProvider>
      </Provider>
    </ThemeProvider>
  </React.Fragment>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();
